import React, { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import axios from "axios";
import Swal from "sweetalert2";
import "./style.css";
import "@github/relative-time-element";
import { FaEdit } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";

function Servicios() {
  const [data, setData] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");

  const filteredData = searchValue
    ? data.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : data;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  const updateService = async (id) => {
    let serviceTypes;
    try {
      const resService = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_service_types`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        serviceTypes = res.data.data;
      }

      if (resService.data.code === 1) {
        const data = resService.data.data[0];
        const reactComponentHtml = ReactDOMServer.renderToString(
          <div className="card-body">
            <div className="row">
              <div className="col-sm-12">
                <form
                  className="form-horizontal fv-form fv-form-bootstrap"
                  acceptCharset="UTF-8"
                  id="formValidation"
                  encType="multipart/form-data"
                  noValidate="novalidate"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="rootwizard">
                    <br />
                    <div className="tab-content">
                      <div className="tab-pane fade show active" id="tab1">
                        {/* Nombre */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="name"
                          >
                            Nombre <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="name"
                              className={`form-control`}
                              placeholder="Nombre"
                              name="name"
                              type="text"
                              data-fv-field="name"
                              value={data.name}
                            />
                          </div>
                        </div>

                        {/* Tipo de servicio */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="tipo_servicio"
                          >
                            Tipo de servicio{" "}
                            <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <select
                              className={`form-control`}
                              name="tipo_servicio"
                              data-fv-field="tipo_servicio"
                              id="tipo_servicio"
                            >
                              <option selected="selected" value="selected">
                                Tipo de servicio
                              </option>
                              {serviceTypes.map((serviceType) => (
                                <option
                                  value={serviceType.id}
                                  selected={
                                    serviceType.id ===
                                    data.notification_service_type_id
                                  }
                                >
                                  {serviceType.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* URL */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="url"
                          >
                            URL <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="url"
                              className={`form-control`}
                              placeholder="URL"
                              name="url"
                              type="text"
                              data-fv-field="url"
                              value={data.url}
                            />
                          </div>
                        </div>

                        {/* Usuario */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="user"
                          >
                            Usuario
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="user"
                              className={`form-control`}
                              placeholder="Usuario"
                              name="user"
                              type="text"
                              data-fv-field="user"
                              value={data.user}
                            />
                          </div>
                        </div>

                        {/* Password */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="password"
                          >
                            Password
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="password"
                              className={`form-control`}
                              placeholder="Password"
                              name="password"
                              type="password"
                              data-fv-field="password"
                              value={data.pass}
                            />
                          </div>
                        </div>

                        {/* Puerto/Path */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="puerto"
                          >
                            Puerto/Path
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="puerto"
                              className={`form-control `}
                              placeholder="Puerto/Path"
                              name="puerto"
                              type="text"
                              data-fv-field="puerto"
                              value={data.port}
                            />
                          </div>
                        </div>

                        {/* Nombre DB */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="nameDB"
                          >
                            Nombre DB
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="nameDB"
                              className={`form-control`}
                              placeholder="Nombre DB"
                              name="nameDB"
                              type="text"
                              data-fv-field="nameDB"
                              value={data.db_name}
                            />
                          </div>
                        </div>

                        {/* Descripción */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label text-black"
                            htmlFor="description"
                          >
                            Descripción
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="description"
                              className={`form-control`}
                              placeholder="Descripción"
                              name="description"
                              type="text"
                              data-fv-field="description"
                              value={data.description}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        );

        let nameInput;
        let tipoServicio;
        let urlInput;
        let userInput;
        let paswordInput;
        let puertoInput;
        let nameDBInput;
        let descriptionInput;

        const result = await Swal.fire({
          title: "Actualizar Servicio",
          html: reactComponentHtml,
          showDenyButton: true,
          confirmButtonText: "Actualizar",
          denyButtonText: "Cancelar",
          width: 1000,
          padding: "1px",
          color: "#716add",
          backdrop: `
            rgba(0,0,0,0.8)
          `,
          customClass: {
            confirmButton: "btn-amc-blue",
            denyButton: "btn-cancel",
            title: "alert-title",
            popup: "alert-bg",
          },
          focusConfirm: false,
          didOpen: () => {
            const popup = Swal.getPopup();
            nameInput = popup.querySelector("#name");
            tipoServicio = popup.querySelector("#tipo_servicio");
            urlInput = popup.querySelector("#url");
            userInput = popup.querySelector("#user");
            paswordInput = popup.querySelector("#password");
            puertoInput = popup.querySelector("#puerto");
            nameDBInput = popup.querySelector("#nameDB");
            descriptionInput = popup.querySelector("#description");

            // ⛔️ Bloquear Enter para todo el popup
            popup.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            });
          },
          preConfirm: async () => {
            const name = nameInput.value;
            const tipo_servico = tipoServicio.value;
            const url = urlInput.value;
            const user = userInput.value;
            const password = paswordInput.value;
            const puerto = puertoInput.value;
            const nameDB = nameDBInput.value;
            const description = descriptionInput.value;

            // Validación de campos requeridos
            if (!name || !tipo_servico || !url) {
              Swal.showValidationMessage(
                `Los campos Nombre, Tipo de servicio y Url son requeridos`
              );
              return false;
            }

            // Validación del nombre
            if (name.length < 3 || name.length > 255) {
              Swal.showValidationMessage(
                `Por favor introduce un Nombre con una longitud entre 3 y 255 caracteres`
              );
              return false;
            }

            // Validación del URL
            if (url.length < 3 || url.length > 255) {
              Swal.showValidationMessage(
                `Por favor introduce una Url con una longitud entre 3 y 255 caracteres`
              );
              return false;
            }

            // Validación de Tipo de servicio
            if (tipo_servico === "selected") {
              Swal.showValidationMessage(`Selecciona un tipo de servicio`);
              return false;
            }

            // Validación del usuario
            if (user && (user.length < 3 || user.length > 255)) {
              Swal.showValidationMessage(
                `Por favor introduce un Usuario con una longitud entre 3 y 255 caracteres`
              );
              return false;
            }

            // Validación de la contraseña
            if (password && (password.length < 3 || password.length > 255)) {
              Swal.showValidationMessage(
                `Por favor introduce una Contraseña con una longitud entre 3 y 255 caracteres`
              );
              return false;
            }

            // Validación del Puerto/Path
            if (puerto && (puerto.length < 3 || puerto.length > 255)) {
              Swal.showValidationMessage(
                `Por favor introduce un Puerto/Path con una longitud entre 3 y 255 caracteres`
              );
              return false;
            }

            // Validación del Nombre de la base de datos
            if (nameDB && (nameDB.length < 3 || nameDB.length > 255)) {
              Swal.showValidationMessage(
                `Por favor introduce un Nombre DB con una longitud entre 3 y 255 caracteres`
              );
              return false;
            }

            // Validación de la Descripción
            if (
              description &&
              (description.length < 3 || description.length > 255)
            ) {
              Swal.showValidationMessage(
                `Por favor introduce una Descripción con una longitud entre 3 y 255 caracteres`
              );
              return false;
            }

            const data = {
              name: name,
              notification_service_type_id: tipo_servico,
              url: url,
              user: user,
              pass: password,
              port: puerto,
              db_name: nameDB,
              description: description,
            };

            const updateResponse = await axios.put(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services/update/${id}`,
              data,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                },
              }
            );

            if (updateResponse.data.code === 1) {
              Swal.fire(
                "Actualizado!",
                "El servicio ha sido actualizado.",
                "success"
              );
              setUpdateTrigger(!updateTrigger);
            } else {
              throw Error(updateResponse);
            }

            return true;
          },
        });

        // Si el usuario cancela, result.dismiss contendrá el valor "cancel"
        if (result.dismiss === "cancel") {
          // Lógica para el caso de cancelar
        }
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data) {
        if (error.response.data.message === "Validation Error") {
          Swal.fire(
            "Error",
            "Por favor validar los datos ingresados",
            "warning"
          );
        } else if (error.response.data.message === "Insert Error") {
          Swal.fire(
            "Error",
            "Error al insertar en base de datos por favor intente mas tarde",
            "warning"
          );
        }
      } else {
        Swal.fire("Error", "Hubo un error", "error");
      }
    }
  };

  const deleteServicio = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "Seguro que desea eliminar este registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );

        Swal.fire("¡Eliminado!", "El servicio ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "No se realizo ninguna accion", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extraer los componentes de la fecha y la hora
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Formatear la fecha y la hora en el formato deseado
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  };

  const getData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        const sorted = res.data.data.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        setData(sorted);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getSeviceType = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_service_types`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setServiceTypes(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
    getSeviceType();
  }, [updateTrigger]);

  const getNameServiceTypes = (id) => {
    const servicio = serviceTypes.filter((data) => data.id === id);
    if (servicio.length > 0) {
      return servicio[0].name;
    }
    return id;
  };

  return (
    <>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer"
          id="datatables_wrapper"
        >
          <div className="row justify-content-between mb-2">
            <div className="col-sm-12 col-md-4">
              <div className="dataTables_length" id="dataTables_length">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 p-2">Mostrar</span>
                  <select
                    name="datatables_length"
                    aria-controls="datatables_length"
                    className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                    onChange={showEntries}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="ml-2 p-2">Registros</span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4">
              <div className="datatables_filter" id="datatables_filter">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 mt1 p-2">Buscar</span>
                  <input
                    type="search"
                    id="searchInput"
                    className="form-control form-control-sm"
                    placeholder
                    aria-controls="datatables"
                  />
                  <button className="btn-amc-blue ml-2" onClick={handleSearch}>
                    Buscar
                  </button>
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "81.2031px" }}
                    >
                      ID
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "178.203px" }}
                    >
                      Nombre
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "180.766px" }}
                    >
                      Tipo de servicio
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Creado
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "159.453px" }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((data) => (
                    <tr key={data.id}>
                      <td>{data.id}</td>
                      <td>{data.name}</td>
                      <td>
                        {getNameServiceTypes(data.notification_service_type_id)}
                      </td>
                      <td>
                        <relative-time
                          datetime={formatDate(data.created_at)}
                          lang="es"
                        />
                      </td>
                      <td>
                        <FaEdit
                          className="btn-edit"
                          onClick={() => {
                            updateService(data.id);
                          }}
                        />
                        <MdOutlineClose
                          className="btn-delete"
                          onClick={() => {
                            deleteServicio(data.id);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default Servicios;
